module.exports = __webpack_public_path__ + "static/media/heliRaise.a8d793a0.png";